import React from 'react';
import { Typography } from '@mui/material';

import Table from '../../../../components/tables/Table';
import tableStyles from '../../../../components/tables/Table.styles';

import {
  getMeterTypeName,
  formatDate,
  safeTrim,
} from '../../utils/evn.helpers';

export default function EVNVersionTable({
  rows = [],
  unit = null,
  evn = null,
  onOpenMeter = () => {},
}) {
  const COLUMNS = [
    {
      label: 'Status',
      field: 'meterStatus',
      type: 'string',
      sortable: true,
    },
    {
      label: 'Meter Number',
      field: 'MeterNumber',
      type: 'string',
      sortable: true,
      render: (row, v) =>
        v ? (
          <Typography
            sx={tableStyles.tableLink}
            onClick={() => onOpenMeter(String(v), { unit, evn })}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onOpenMeter(String(v), { unit, evn });
              }
            }}
          >
            {v}
          </Typography>
        ) : (
          '—'
        ),
    },
    {
      label: 'Meter Type',
      field: 'MeterType',
      type: 'string',
      sortable: true,
      accessor: (row) => getMeterTypeName(row?.MeterType) ?? '—',
      render: (_row, v) => v ?? '—',
    },
    {
      label: 'From Date',
      field: 'FromDate',
      type: 'date',
      sortable: true,
      render: (_row, v) => formatDate(v),
    },
    {
      label: 'To Date',
      field: 'ToDate',
      type: 'date',
      sortable: true,
      render: (_row, v) => formatDate(v),
    },
    {
      label: 'Comments',
      field: 'Comments',
      type: 'string',
      sortable: true,
      accessor: (row) => safeTrim(row?.Comments) || '—',
      render: (_row, v) => safeTrim(v) || '—',
    },
    {
      label: 'Faulty',
      field: 'Faulty',
      type: 'boolean',
      sortable: true,
    },
    {
      label: 'Creation Date',
      field: 'AssignmentRecordedOn',
      type: 'date',
      sortable: true,
      render: (_row, v) => formatDate(v),
    },
  ];

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={COLUMNS}
      stickyHeader
      zebra
      hover
      bordered

      defaultSort={{ field: 'FromDate', direction: 'desc' }}
    />
  );
}